import React from 'react'
import { BrowserRouter } from 'react-router-dom';
import './assets/css/lightbox.min.css';
import './assets/css/style.css';
import './assets/css/layout.css';

import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import Loader from './components/Loader';
import AppRouter from './components/AppRouter';
import { AuthProvider } from './auth/AuthContext';
import { LanguageProvider } from './i18n';



function App() {

  // BrowserRouter must wrap Header too: Header renders <Link>, and a Link
  // outside router context throws "Cannot destructure property 'basename'".
  //
  // AuthProvider sits inside BrowserRouter (it navigates) and outside Header
  // (the nav reads auth state to decide whether to show the portfolio link).
  return (
   <BrowserRouter>
    <AuthProvider>
     {/* Wraps the chrome as well as the routes: Header, Footer and Sidebar
         render on the signed-in pages too, and translate there. The provider
         itself decides, from the route, when a language other than English
         applies — so the public site is unaffected. */}
     <LanguageProvider>
      <Header></Header>
      <AppRouter></AppRouter>
      <Footer></Footer>
      <Sidebar></Sidebar>
      <Loader></Loader>
     </LanguageProvider>
    </AuthProvider>
   </BrowserRouter>
  )
}

export default App;
